export default "__VITE_ASSET__CP_3T5yW__"